// Added by Sejune Oh on 2019-02-15
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { ComponentType } from 'react'
import { MuiThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Custom Theme
import CoreLineTheme from '../styles/Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function provideTheme<P>(Component: ComponentType<P>) {
    function provideTheme(props: P) {
        // MuiThemeProvider makes the theme available down the React tree
        // thanks to React context.
        return (
            <MuiThemeProvider theme={CoreLineTheme}>
                {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                <CssBaseline />
                <Component {...props} />
            </MuiThemeProvider>
        )
    }

    return provideTheme
}

export default provideTheme
